import {
  Button,
  Card,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  InputAdornment,
  Radio,
  RadioGroup,
  Stack,
  TextField,
  Tooltip,
  Typography,
} from '@mui/material';
import PropTypes from 'prop-types';
// import MenuItem from "@mui/material/MenuItem";
import Iconify from '../../components/Iconify';
import { FaTimes } from 'react-icons/fa';
import React, { useRef } from 'react';
// import MessageTemplate from "src/dao/MessageTemplate";
// import PhoneNumber from "src/dao/PhoneNumber";
// import { useParams } from "react-router-dom";

const headerTypeOptions = [
  { label: 'Text', value: 'TEXT' },
  { label: 'Image', value: 'IMAGE' },
  { label: 'Document', value: 'DOCUMENT' },
  { label: 'Video', value: 'VIDEO' },
];

const buttonOptions = [
  { label: 'None', value: 'NONE' },
  { label: 'Phone Broadcast / URL', value: 'PHONE_NUMBER_URL' },
  { label: 'Quick Reply', value: 'QUICK_REPLY' },
];

TemplateForm2.propTypes = {
  name: PropTypes.string,
  language: PropTypes.object,
  header: PropTypes.object,
  body: PropTypes.object,
  footer: PropTypes.object,
  uploadFile: PropTypes.object,

  setHeader: PropTypes.func,
  setBody: PropTypes.func,
  setFooter: PropTypes.func,
  setUploadFile: PropTypes.func,

  phoneNumberUrlArray: PropTypes.array,
  setPhoneNumberUrlArray: PropTypes.func,
  quickReplyArray: PropTypes.array,
  setQuickReplyArray: PropTypes.func,
  selectedButton: PropTypes.string,
  setSelectedButton: PropTypes.func,
};

export default function TemplateForm2(props) {
  const {
    name,
    language,
    header,
    body,
    footer,
    // uploadFile,
    phoneNumberUrlArray,
    quickReplyArray,
    selectedButton,
  } = props;

  // const { waba_id } = useParams();
  const bodyRef = useRef(null);

  // const [loadingUploadTemplate, setLoadingUploadTemplate] = useState(false);

  const formatText = (char) => {
    const { selectionStart, selectionEnd } = bodyRef.current;
    let arr = body.text.split('');
    arr.splice(selectionStart, 0, char);
    arr.splice(selectionEnd + 1, 0, char);
    props.setBody({
      ...body,
      text: arr.join(''),
    });
  };

  const addVariable = (e) => {
    const pattern = /{{\d}}/g;
    const array = [...body.text.matchAll(pattern)];
    const count = array.length + 1;
    props.setBody({
      ...body,
      text: body.text + ` {{${count}}}`,
    });
  };

  const addVariableHeader = (e) => {
    const pattern = /{{\d}}/g;
    const array = [...header.text.matchAll(pattern)];
    const count = array.length + 1;
    props.setHeader({
      ...header,
      text: header.text + ` {{${count}}}`,
    });
  };

  const addQuickReply = () => {
    let temp = [...quickReplyArray];
    temp.push({
      type: 'QUICK_REPLY',
      text: '',
    });
    props.setQuickReplyArray(temp);
  };

  const addPhoneNumber = () => {
    let temp = [...phoneNumberUrlArray];
    temp.push({
      type: 'PHONE_NUMBER',
      url: '',
      text: '',
    });
    props.setPhoneNumberUrlArray(temp);
  };

  const addURL = () => {
    let temp = [...phoneNumberUrlArray];
    temp.push({
      type: 'URL',
      url: '',
      text: '',
    });
    props.setPhoneNumberUrlArray(temp);
  };

  const isPhoneNumberButtonThere = () => {
    let res = phoneNumberUrlArray.find((obj) => obj.type === 'PHONE_NUMBER');
    return !!res;
  };

  const isURLButtonThere = () => {
    let res = phoneNumberUrlArray.find((obj) => obj.type === 'URL');
    return !!res;
  };

  const deletePhoneNumberButton = () => {
    let index = phoneNumberUrlArray.findIndex(
      (obj) => obj.type === 'PHONE_NUMBER'
    );
    let temp = [...phoneNumberUrlArray];
    temp.splice(index, 1);
    props.setPhoneNumberUrlArray(temp);
  };

  const deleteURLButton = () => {
    let index = phoneNumberUrlArray.findIndex((obj) => obj.type === 'URL');
    let temp = [...phoneNumberUrlArray];
    temp.splice(index, 1);
    props.setPhoneNumberUrlArray(temp);
  };

  const headerSampleCount = () => {
    const parameter = header.text.match(/\{{\d+}}/g);
    return parameter ?? [];
  };

  // const handleUploadTemolateClick = async (type = "") => {
  //   const input = document.createElement("input");
  //   input.type = "file";
  //   switch (type) {
  //     case "document":
  //       input.accept =
  //         ".pdf,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document";
  //       break;
  //     case "image":
  //       input.accept = "image/*";
  //       break;
  //     case "video":
  //       input.accept = "video/mp4,video/x-m4v,video/*,";
  //       break;

  //     default:
  //       input.accept = "";
  //       break;
  //   }
  //   input.onchange = async (e) => {
  //     try {
  //       setLoadingUploadTemplate(true);
  //       const file = e.target.files[0];
  //       let formData = new FormData();
  //       formData.append("folder", "wa_panel");
  //       formData.append("directory", "wa_panel");
  //       formData.append("public", true);
  //       formData.append("files", file);
  //       // let phone = await PhoneNumber.getAll(waba_id);
  //       // let key = await PhoneNumber.getToken({ number: "fetchNumId" });
  //       let url = await MessageTemplate.postImage(formData);
  //       props.setHeader({ ...header, file: url.data[0] });
  //       props.setUploadFile(url.data[0]);
  //       setLoadingUploadTemplate(false);
  //     } catch (e) {
  //       setLoadingUploadTemplate(false);
  //     }
  //   };
  //   await input.click();
  // };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={3}>
        <Card sx={{ p: 4 }}>
          <Stack spacing={3}>
            <Typography variant="h6">Language</Typography>
            <FormControl>
              <RadioGroup value={language.code} defaultValue="id">
                <FormControlLabel
                  value={language.code}
                  control={<Radio />}
                  label={language.language}
                />
              </RadioGroup>
            </FormControl>
          </Stack>
        </Card>
      </Grid>
      <Grid item xs={12} md={9}>
        <Stack spacing={2}>
          <Card sx={{ p: 4 }}>
            <Stack spacing={2}>
              <Typography variant="h6">Template Name</Typography>
              <Typography paragraph>{name}</Typography>
            </Stack>
          </Card>

          <Card sx={{ p: 4 }}>
            <Stack spacing={1}>
              <Stack
                spacing={1}
                direction="row"
                alignItems="center"
                sx={{ mb: 2 }}
              >
                <Typography variant="h6">Header</Typography>
                <Typography variant="p" sx={{ color: 'gray' }}>
                  (Optional)
                </Typography>
              </Stack>
              <Typography paragraph sx={{ fontSize: '0.8em' }}>
                Add title or choose which type of media you'll use for this
                header.
              </Typography>
              <FormControl>
                <RadioGroup
                  style={{ display: 'inline' }}
                  value={header.format}
                  onChange={(e) => {
                    props.setHeader({ ...header, format: e.target.value });
                  }}
                >
                  {headerTypeOptions.map((obj, key) => {
                    return (
                      <FormControlLabel
                        key={key}
                        value={obj.value}
                        control={<Radio />}
                        label={obj.label}
                      />
                    );
                  })}
                </RadioGroup>
              </FormControl>
            </Stack>
            {header.format === 'TEXT' && (
              <>
                <Stack spacing={1}>
                  <TextField
                    value={header.text}
                    onChange={(e) => {
                      props.setHeader({ ...header, text: e.target.value });
                    }}
                    style={{ marginTop: 10 }}
                    fullWidth
                    label="Text"
                    InputLabelProps={{ shrink: true }}
                  />
                </Stack>
                <Stack spacing={1} pt="10px" alignItems="end">
                  <div>
                    <Button
                      variant="contained"
                      startIcon={<Iconify icon="akar-icons:plus" />}
                      onClick={addVariableHeader}
                      disabled={headerSampleCount().length > 0}
                    >
                      Add Variable
                    </Button>
                  </div>
                </Stack>
              </>
            )}
            {/* {header.format !== "TEXT" && (
              <div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "flex-end",
                  }}
                >
                  <input
                    onChange={(event) => uploadFile(event)}
                    type="file"
                    style={{ display: "none" }}
                  />
                  <Button
                    onClick={() =>
                      handleUploadTemolateClick(header.format.toLowerCase())
                    }
                    style={{
                      height: 60,
                      color: "black",
                      fontWeight: 400,
                      fontSize: "1em",
                      marginTop: 40,
                      background: "#f5f5f5",
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "center",
                      borderRadius: 20,
                      paddingRight: 30,
                      marginRight: 0,
                      boxShadow: "none",
                    }}
                    disabled={loadingUploadTemplate}
                  >
                    <div
                      style={{
                        fontWeight: 500,
                        display: "flex",
                        //alignItems: "center",
                        flexDirection: "row",
                      }}
                    >
                      <div
                        style={{
                          background: "#6260dc",
                          height: "1.5em",
                          width: "1.5em",
                          borderRadius: "1em",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          marginRight: 15,
                          marginLeft: 6,
                          fontSize: "0.9em",
                        }}
                      >
                        <Iconify
                          color={"white"}
                          icon={"ic:outline-file-upload"}
                        />
                      </div>
                      {loadingUploadTemplate ? "Loading..." : "Upload Data"}
                    </div>
                  </Button>

                  {uploadFile && (
                    <Button
                      style={{
                        border: "1px solid #6260dc",
                        height: 40,
                        color: "black",
                        fontWeight: 400,
                        fontSize: "0.8em",
                        marginTop: 40,
                        background: "white",
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "left",
                        borderRadius: 20,
                        paddingRight: 10,
                        textTransform: "none",
                        marginLeft: 15,
                      }}
                    >
                      <a download href={uploadFile.url}>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                          }}
                        >
                          <div
                            style={{
                              background: "#6260dc",
                              height: "2em",
                              width: "2em",
                              borderRadius: "2em",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              marginRight: 6,
                            }}
                          >
                            <Iconify
                              color={"white"}
                              icon={"mdi:paper-outline"}
                            />
                          </div>
                          <div
                            style={{
                              fontSize: "0.8em",
                            }}
                          >
                            {uploadFile.fileName}
                          </div>
                        </div>
                      </a>
                      <Iconify
                        onClick={() => {
                          props.setUploadFile(null);
                          // setUploadedFileNameExcel(null);
                          // setUploadedFileName(null);
                          // setUploadedFile(null);
                        }}
                        color={"grey"}
                        icon={"uil:times"}
                      />
                    </Button>
                  )}
                </div>
              </div>
              // </Col>
            )} */}
          </Card>
          <Card sx={{ p: 4 }}>
            <Stack spacing={2}>
              <Stack direction="row" justifyContent="space-between">
                <Typography variant="h6">Body</Typography>
              </Stack>
              <Typography paragraph sx={{ fontSize: '0.8em' }}>
                Enter the text for your message in the language you've selected.
              </Typography>
              <Stack spacing={0}>
                <TextField
                  sx={{
                    '& legend': { display: 'none' },
                    '& fieldset': { top: 0 },
                  }}
                  value={body.text}
                  inputRef={bodyRef}
                  multiline
                  rows={5}
                  inputProps={{ maxLength: 1024 }}
                  onChange={(e) => {
                    props.setBody({ ...body, text: e.target.value });
                  }}
                />
                <Typography align="right" sx={{ fontSize: '0.8em' }}>
                  {body.text.length}/1024
                </Typography>
              </Stack>
              <Stack direction="row" justifyContent="space-between">
                <Stack direction="row" spacing="1">
                  <IconButton sx={{ height: '100%' }}>
                    <Iconify
                      icon="ant-design:smile-outlined"
                      height={22}
                      width={22}
                    />
                  </IconButton>
                  <Tooltip title="Formats the selected text to bold.">
                    <IconButton
                      sx={{ height: '100%' }}
                      onClick={() => formatText('*')}
                    >
                      <Iconify icon="ant-design:bold" height={22} width={22} />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Formats the selected text to italic.">
                    <IconButton
                      sx={{ height: '100%' }}
                      onClick={() => formatText('_')}
                    >
                      <Iconify
                        icon="ant-design:italic"
                        height={22}
                        width={22}
                      />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Formats the selected text to strikethrough.">
                    <IconButton
                      sx={{ height: '100%' }}
                      onClick={() => formatText('~')}
                    >
                      <Iconify
                        icon="ant-design:strikethrough"
                        height={22}
                        width={22}
                      />
                    </IconButton>
                  </Tooltip>
                </Stack>
                <Stack direction="row" spacing="2">
                  <Button
                    variant="contained"
                    startIcon={<Iconify icon="akar-icons:plus" />}
                    onClick={addVariable}
                  >
                    Add Variable
                  </Button>
                  <IconButton sx={{ height: '100%' }}>
                    <Iconify icon="akar-icons:info" height={22} width={22} />
                  </IconButton>
                </Stack>
              </Stack>
            </Stack>
          </Card>
          <Card sx={{ p: 4 }}>
            <Stack spacing={2}>
              <Stack
                spacing={1}
                direction="row"
                alignItems="center"
                sx={{ mb: 2 }}
              >
                <Typography variant="h6">Footer</Typography>
                <Typography variant="p" sx={{ color: 'gray' }}>
                  (Optional)
                </Typography>
              </Stack>
              <Typography paragraph sx={{ fontSize: '0.8em' }}>
                Add a short line of text to the bottom of your message
                templates.
              </Typography>
              <TextField
                sx={{
                  '& legend': { display: 'none' },
                  '& fieldset': { top: 0 },
                }}
                inputProps={{ maxLength: 50 }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      {footer.text.length}/50
                    </InputAdornment>
                  ),
                }}
                onChange={(e) => {
                  props.setFooter({ ...footer, text: e.target.value });
                }}
              />
            </Stack>
          </Card>
          <Card sx={{ p: 4 }}>
            <Stack spacing={1}>
              <Stack
                spacing={1}
                direction="row"
                alignItems="center"
                sx={{ mb: 2 }}
              >
                <Typography variant="h6">Button</Typography>
                <Typography variant="p" sx={{ color: 'gray' }}>
                  (Optional)
                </Typography>
              </Stack>
              <Typography paragraph sx={{ fontSize: '0.8em' }}>
                Create buttons that let customers respond to your message or
                take action.
              </Typography>
              <FormControl>
                <RadioGroup
                  value={selectedButton}
                  onChange={(e) => {
                    props.setSelectedButton(e.target.value);
                  }}
                  row
                  defaultValue="none"
                >
                  {buttonOptions.map((obj, key) => {
                    return (
                      <FormControlLabel
                        key={key}
                        value={obj.value}
                        control={<Radio />}
                        label={obj.label}
                      />
                    );
                  })}
                </RadioGroup>
              </FormControl>
            </Stack>
            {selectedButton === 'PHONE_NUMBER_URL' && (
              <Stack spacing={1}>
                {phoneNumberUrlArray.map((obj, key) => {
                  const changeNameData = (e) => {
                    let temp = [...phoneNumberUrlArray];
                    temp[key].text = e.target.value;
                    props.setPhoneNumberUrlArray(temp);
                  };

                  if (obj.type === 'URL') {
                    return (
                      <div key={key}>
                        <Typography
                          style={{
                            marginTop: 10,
                            display: 'flex',
                            alignItems: 'center',
                          }}
                          variant="h6"
                        >
                          URL
                          <FaTimes
                            onClick={() => {
                              deleteURLButton();
                            }}
                            style={{
                              marginLeft: 5,
                              color: 'grey',
                              cursor: 'pointer',
                            }}
                          />
                        </Typography>
                        <TextField
                          inputProps={{ maxLength: 25 }}
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                {obj.text.length}/25
                              </InputAdornment>
                            ),
                          }}
                          value={obj.text}
                          onChange={(e) => {
                            changeNameData(e);
                          }}
                          style={{
                            marginTop: 10,
                            marginBottom: 15,
                          }}
                          fullWidth
                          label="Text"
                          InputLabelProps={{ shrink: true }}
                        />
                        <TextField
                          value={obj.url}
                          onChange={(e) => {
                            // console.log("!!!", e.target.value);
                            let temp = [...phoneNumberUrlArray];
                            temp[key].url = e.target.value;
                            props.setPhoneNumberUrlArray(temp);
                          }}
                          style={{
                            marginTop: 10,
                          }}
                          fullWidth
                          label="URL"
                          InputLabelProps={{ shrink: true }}
                        />
                      </div>
                    );
                  } else {
                    return (
                      <div key={key}>
                        <Typography
                          style={{
                            marginTop: 10,
                            display: 'flex',
                            alignItems: 'center',
                          }}
                          variant="h6"
                        >
                          Phone Broadcast
                          <FaTimes
                            onClick={() => {
                              deletePhoneNumberButton();
                            }}
                            style={{
                              marginLeft: 5,
                              color: 'grey',
                              cursor: 'pointer',
                            }}
                          />
                        </Typography>
                        <TextField
                          inputProps={{ maxLength: 25 }}
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                {obj.text.length}/25
                              </InputAdornment>
                            ),
                          }}
                          value={obj.text}
                          onChange={(e) => {
                            changeNameData(e);
                          }}
                          style={{
                            marginTop: 10,
                            marginBottom: 15,
                          }}
                          fullWidth
                          label="Text"
                          InputLabelProps={{ shrink: true }}
                        />

                        <TextField
                          value={obj.phone_number}
                          onChange={(e) => {
                            let temp = [...phoneNumberUrlArray];
                            temp[key].phone_number = e.target.value;
                            props.setPhoneNumberUrlArray(temp);
                          }}
                          style={{
                            marginTop: 10,
                          }}
                          fullWidth
                          label="Phone Broadcast"
                          InputLabelProps={{ shrink: true }}
                        />
                      </div>
                    );
                  }
                })}
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    marginTop: 20,
                  }}
                >
                  {!isPhoneNumberButtonThere() && (
                    <Button
                      variant="contained"
                      startIcon={<Iconify icon="akar-icons:plus" />}
                      onClick={addPhoneNumber}
                    >
                      Add Phone Broadcast
                    </Button>
                  )}

                  {!isURLButtonThere() && (
                    <Button
                      style={{ marginLeft: 10 }}
                      variant="contained"
                      startIcon={<Iconify icon="akar-icons:plus" />}
                      onClick={addURL}
                    >
                      Add URL
                    </Button>
                  )}
                </div>
              </Stack>
            )}
            {selectedButton === 'QUICK_REPLY' && (
              <Stack spacing={1}>
                {quickReplyArray.map((obj, key) => {
                  const changeTextData = (e) => {
                    let temp = [...quickReplyArray];
                    temp[key].text = e.target.value;
                    props.setQuickReplyArray(temp);
                  };

                  const deleteData = (e) => {
                    let temp = [...quickReplyArray];
                    temp.splice(key, 1);
                    props.setQuickReplyArray(temp);
                  };

                  return (
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                      }}
                      key={key}
                    >
                      <TextField
                        inputProps={{ maxLength: 25 }}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              {obj.text.length}/25
                            </InputAdornment>
                          ),
                        }}
                        value={obj.text}
                        onChange={(e) => {
                          changeTextData(e);
                        }}
                        style={{
                          marginTop: 10,
                          marginBottom: 15,
                        }}
                        fullWidth
                        label={`Button ${key + 1}`}
                        InputLabelProps={{ shrink: true }}
                      />
                      <FaTimes
                        onClick={() => {
                          deleteData();
                        }}
                        style={{
                          marginLeft: 5,
                          color: 'grey',
                          cursor: 'pointer',
                        }}
                      />
                    </div>
                  );
                })}
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    marginTop: 20,
                  }}
                >
                  {quickReplyArray.length < 3 && (
                    <Button
                      variant="contained"
                      startIcon={<Iconify icon="akar-icons:plus" />}
                      onClick={addQuickReply}
                    >
                      Add Quick Reply
                    </Button>
                  )}
                </div>
              </Stack>
            )}
          </Card>
        </Stack>
      </Grid>
    </Grid>
  );
}
